import { render } from "./VodacomSouthAfricaPrizes.vue?vue&type=template&id=d60f7fa4&scoped=true"
import script from "./VodacomSouthAfricaPrizes.vue?vue&type=script&lang=js"
export * from "./VodacomSouthAfricaPrizes.vue?vue&type=script&lang=js"

import "./VodacomSouthAfricaPrizes.vue?vue&type=style&index=0&id=d60f7fa4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d60f7fa4"]])

export default __exports__